import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import InputSelect from '@components/InputSelect';

import type { StepProps } from '../types';

export const Step1: FC<
  StepProps & {
    endorsementSummaryTemplates: { value: number; name: string }[];
    isFetchingEndorsementSummaryTemplates: boolean;
  }
> = ({ control, isReadOnly = false, endorsementSummaryTemplates, isFetchingEndorsementSummaryTemplates }) => (
  <Controller
    control={control}
    name="endorsement_summary_template_id"
    render={({ field, fieldState: { error } }) => (
      <InputSelect
        {...field}
        isFetchingOptions={isFetchingEndorsementSummaryTemplates}
        isReadOnly={isReadOnly}
        isSearchable={false}
        labelText="Select a blank endorsement template"
        options={endorsementSummaryTemplates}
        errors={error?.message}
        dataTestId="select:endorsement-summary-template-id"
        shouldRenderInsidePortal
      />
    )}
  />
);
